import React from "react";
import PropTypes from "prop-types";
import { typesArray } from "./constants";
import ContentRenderer from "../contentRenderer/ContentRenderer";

const FormSubmitFeedback = ({ title, message, type, errorRef }) => (
	<div className="form-message" data-type={type} ref={errorRef}>
		<div>
			<h6>{title}</h6>
			<ContentRenderer contentBody={message} contentElementType="p" />
		</div>
	</div>
);

FormSubmitFeedback.propTypes = {
	title: PropTypes.string,
	message: PropTypes.node,
	type: PropTypes.oneOf(typesArray)
};

export default FormSubmitFeedback;
